import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isPrivateOrAuthPath } from '../utils/subdomain';
import authStorage from '../utils/authStorage';

export const useSubdomainRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port ? `:${window.location.port}` : '';
    const path = location.pathname + location.search + location.hash;

    // Only redirect if we are accessing via the domain (or hosts map)
    if (!hostname.endsWith('topinteriorsindia.com')) {
      return;
    }

    // Special handling for accessing the root of my-account subdomain
    const isRootPath = location.pathname === '/' || window.location.pathname === '/' || location.pathname === '/index.html' || window.location.pathname === '/index.html';
    if (hostname.startsWith('my-account.') && isRootPath) {
      const rawToken = authStorage.getItem('token');
      const token = (rawToken && rawToken !== 'null' && rawToken !== 'undefined') ? rawToken : null;
      
      if (!token) {
        // Not logged in -> Redirect to login page on the same subdomain
        const targetUrl = `${protocol}//my-account.topinteriorsindia.com${port}/login`;
        window.location.replace(targetUrl);
        return;
      }

      // Check user roles by parsing the JWT token
      let roles = [];
      try {
        const parts = token.split('.');
        if (parts.length === 3) {
          const base64Url = parts[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split('')
              .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
              .join('')
          );
          const payload = JSON.parse(jsonPayload);
          if (payload && payload.roles) {
            roles = payload.roles.split(',').map(r => r.trim());
          }
        }
      } catch (e) {
        console.error("Failed to decode token for subdomain redirect", e);
      }

      const isAdmin = roles.some(r => [
        'ROLE_SUPER_ADMIN', 
        'ROLE_SALES_ADMIN', 
        'ROLE_LISTING_ADMIN', 
        'ROLE_SUPPORT_ADMIN', 
        'ROLE_ADMIN',
        'ROLE_MAGAZINE_SALES'
      ].includes(r));

      if (isAdmin) {
        // Admin -> Redirect to /admin on the same subdomain
        const targetUrl = `${protocol}//my-account.topinteriorsindia.com${port}/admin`;
        window.location.replace(targetUrl);
      } else {
        // Vendor -> Redirect to /my-account/manage-listing on the same subdomain
        const targetUrl = `${protocol}//my-account.topinteriorsindia.com${port}/my-account/manage-listing`;
        window.location.replace(targetUrl);
      }
      return;
    }

    const isPrivate = isPrivateOrAuthPath(path);

    if (isPrivate) {
      // Private pages should live on my-account.topinteriorsindia.com
      if (!hostname.startsWith('my-account.')) {
        const targetUrl = `${protocol}//my-account.topinteriorsindia.com${port}${path}`;
        window.location.replace(targetUrl);
      }
    } else {
      // Public pages should live on vendor.topinteriorsindia.com
      if (!hostname.startsWith('vendor.')) {
        const targetUrl = `${protocol}//vendor.topinteriorsindia.com${port}${path}`;
        window.location.replace(targetUrl);
      }
    }
  }, [location]);
};

export default useSubdomainRedirect;
